import { z } from 'zod';
import rawMeta from '../../content/anim/clipMeta.json';

/**
 * Clip metadata carrying the forensic constants (loopability, root-motion rebase ops, trim
 * points, stride speeds). CharacterView applies these at load time, BEFORE the first
 * clipAction() call — three.js caches property bindings there.
 */
export const ClipMetaSchema = z.object({
  loop: z.boolean(),
  oneShot: z.boolean(),
  trimStartS: z.number().nonnegative().optional(),
  strideSpeedMps: z.number().positive().optional(),
  cadenceHz: z.number().positive().optional(),
  strideLengthM: z.number().positive().optional(),
  phaseOffset01: z.number().min(0).max(1).optional(),
  syncGroup: z.string().optional(),
  hipsYOp: z.enum(['none', 'subtractConstant', 'flattenToRest']).optional(),
  hipsRestOffsetM: z.number().optional(),
});

export type ClipMeta = z.infer<typeof ClipMetaSchema>;

const FileSchema = z.object({
  hipsIdleRestLocal: z.tuple([z.number(), z.number(), z.number()]),
  clips: z.record(z.string(), ClipMetaSchema),
});

export const CLIP_META = FileSchema.parse(rawMeta);

export function metaFor(clip: string): ClipMeta | undefined {
  return CLIP_META.clips[clip];
}
